import { PhxSize, PhxBackground } from './types';

/**
 * PHX_SIZE is an object that maps size identifiers to their string representations.
 * These values can be used to set the size of an element in a more readable way.
 */
export const PHX_SIZE = {
  XXS: 'extra-extra-small',
  XS: 'extra-small',
  SM: 'small',
  MD: 'medium',
  LG: 'large',
  XL: 'extra-large',
  XXL: 'extra-extra-large',
} as const;

/**
 * PHX_SPACING extends PHX_SIZE with additional spacing-specific values.
 */
export const PHX_SPACING = {
  ...PHX_SIZE,
  NONE: 'none',
  SMD: 'small-medium',
  MDL: 'medium-large',
} as const;

/**
 * PHX_ICON_SIZE is an object that maps size identifiers to their pixel values.
 * These values can be used to set the size of an icon in pixels.
 */
export const PHX_ICON_SIZE = {
  XS: 12,
  SM: 16,
  MD: 20,
  LG: 24,
  XL: 32,
  XXL: 64,
} as const;

/**
 * PHX_BACKGROUND is an object that maps background identifiers to their string representations.
 * These values can be used to set the background of an element in a more readable way.
 */
export const PHX_BACKGROUND = {
  STANDARD: 'standard',
  MEDIUM: 'medium',
  BOLD: 'bold',
  SUMMARY: 'summary',
  OVERLAY: 'overlay',
  INVERTED: 'inverted',
  DARK: 'dark',
} as const;

// PHX_SIZES_LIST is an array of all the values in PHX_SIZE.
// This can be used to iterate over all possible sizes, for example when generating a dropdown menu for size selection.
export const PHX_SIZES_LIST: readonly PhxSize[] = Object.values(PHX_SIZE);

// PHX_BACKGROUNDS_LIST is an array of all the values in PHX_BACKGROUND.
// This can be used to iterate over all possible backgrounds, for example when generating a dropdown menu for background selection.
export const PHX_BACKGROUNDS_LIST: readonly PhxBackground[] = Object.values(PHX_BACKGROUND);

export enum PHX_STATSIG_KEYS {
  VIRTUAL_SCROLL_UPDATES = 'virtual-scroll-updates',
  SORT_CONSISTENCY_ENABLED = 'sort-consistency-enabled',
  PHX_SELECT_CUSTOM_TOOLTIP_ENABLED = 'phx-select-custom-tooltip-enabled',
  PHX_SELECT_TOOLTIP_ON_TRUNCATE_ENABLED = 'phx-select-tooltip-on-truncate-enabled',
  PHX_DATE_PICKER_TOGGLE_ENABLED = 'phx-date-picker-toggle-enabled',
}
